/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { GovKoSfrIcon16Light } from './GovKoSfrIcon16Light';
import { GovKoSfrIcon16Regular } from './GovKoSfrIcon16Regular';
import { GovKoSfrIcon16Solid } from './GovKoSfrIcon16Solid';
import { GovKoSfrIcon20Light } from './GovKoSfrIcon20Light';
import { GovKoSfrIcon20Regular } from './GovKoSfrIcon20Regular';
import { GovKoSfrIcon20Solid } from './GovKoSfrIcon20Solid';
import { GovKoSfrIcon24Regular } from './GovKoSfrIcon24Regular';
import { GovKoSfrIcon24Solid } from './GovKoSfrIcon24Solid';
import { GovKoSfrIcon32Regular } from './GovKoSfrIcon32Regular';
import { GovKoSfrIcon64Regular } from './GovKoSfrIcon64Regular';
var sizes = {
    16: {
        light: GovKoSfrIcon16Light,
        regular: GovKoSfrIcon16Regular,
        solid: GovKoSfrIcon16Solid,
    },
    20: {
        light: GovKoSfrIcon20Light,
        regular: GovKoSfrIcon20Regular,
        solid: GovKoSfrIcon20Solid,
    },
    24: {
        regular: GovKoSfrIcon24Regular,
        solid: GovKoSfrIcon24Solid,
    },
    32: {
        regular: GovKoSfrIcon32Regular,
    },
    64: {
        regular: GovKoSfrIcon64Regular,
    },
};
export var GovKoSfrIcon = forwardRef('GovKoSfrIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
